export default {
    getList: {
        getInfo: async function (params) {
            let option = {
                url: '/api/v1/worksheet/edit',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getNotice: async function (params) {
            let option = {
                url: '/api/v1/worksheet/note',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getRecord: async function (params) {
            let option = {
                url: '/api/v1/worksheet/record',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        postFile: async function (params) {
            let option = {
                url: '/api/v1/worksheet/preupload',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        closeNotice: async function (params) {
            let option = {
                url: '/api/v1/worksheet/close',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        updateNotice: async function (params) {
            let option = {
                url: '/api/v1/worksheet/update',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSelectItem: async function (params) {
            let option = {
                url: '/api/v1/worksheet/selectfile',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        downLoadFile: async function (params) {
            let option = {
                url: '/api/v1/worksheet/downloadfile',
                type: 'getFile',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        assignWork: async function (params) {
            let option = {
                url: '/api/v1/worksheet/assign',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        editWork: async function (params) {
            let option = {
                url: '/api/v1/worksheet/edit',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}